/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Big number integer */
  BigInt: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  /** Account address */
  id: Scalars['String']['output'];
  /** Associated operator account */
  operator?: Maybe<Operator>;
  /** Initiated voting rounds by account */
  votingRounds: Array<VotingRound>;
  /** Associated worker account */
  worker?: Maybe<Worker>;
};


export type AccountVotingRoundsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VotingRoundOrderByInput>>;
  where?: InputMaybe<VotingRoundWhereInput>;
};

export type AccountEdge = {
  __typename?: 'AccountEdge';
  cursor: Scalars['String']['output'];
  node: Account;
};

export enum AccountOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  OperatorIdAsc = 'operator_id_ASC',
  OperatorIdAscNullsFirst = 'operator_id_ASC_NULLS_FIRST',
  OperatorIdAscNullsLast = 'operator_id_ASC_NULLS_LAST',
  OperatorIdDesc = 'operator_id_DESC',
  OperatorIdDescNullsFirst = 'operator_id_DESC_NULLS_FIRST',
  OperatorIdDescNullsLast = 'operator_id_DESC_NULLS_LAST',
  WorkerIdAsc = 'worker_id_ASC',
  WorkerIdAscNullsFirst = 'worker_id_ASC_NULLS_FIRST',
  WorkerIdAscNullsLast = 'worker_id_ASC_NULLS_LAST',
  WorkerIdDesc = 'worker_id_DESC',
  WorkerIdDescNullsFirst = 'worker_id_DESC_NULLS_FIRST',
  WorkerIdDescNullsLast = 'worker_id_DESC_NULLS_LAST'
}

export type AccountWhereInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<OperatorWhereInput>;
  operator_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  votingRounds_every?: InputMaybe<VotingRoundWhereInput>;
  votingRounds_none?: InputMaybe<VotingRoundWhereInput>;
  votingRounds_some?: InputMaybe<VotingRoundWhereInput>;
  worker?: InputMaybe<WorkerWhereInput>;
  worker_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  edges: Array<AccountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NominatedWorkerNode = {
  __typename?: 'NominatedWorkerNode';
  blockHash: Scalars['String']['output'];
  blockNumber: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  solution: Solution;
  worker: Worker;
};

export type NominatedWorkerNodeEdge = {
  __typename?: 'NominatedWorkerNodeEdge';
  cursor: Scalars['String']['output'];
  node: NominatedWorkerNode;
};

export type NominatedWorkerNodeHistoriesConnection = {
  __typename?: 'NominatedWorkerNodeHistoriesConnection';
  edges: Array<NominatedWorkerNodeHistoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NominatedWorkerNodeHistory = {
  __typename?: 'NominatedWorkerNodeHistory';
  blockHash: Scalars['String']['output'];
  blockNumber: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  solution: Solution;
  worker: Worker;
};

export type NominatedWorkerNodeHistoryEdge = {
  __typename?: 'NominatedWorkerNodeHistoryEdge';
  cursor: Scalars['String']['output'];
  node: NominatedWorkerNodeHistory;
};

export enum NominatedWorkerNodeHistoryOrderByInput {
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  SolutionIdAsc = 'solution_id_ASC',
  SolutionIdAscNullsFirst = 'solution_id_ASC_NULLS_FIRST',
  SolutionIdAscNullsLast = 'solution_id_ASC_NULLS_LAST',
  SolutionIdDesc = 'solution_id_DESC',
  SolutionIdDescNullsFirst = 'solution_id_DESC_NULLS_FIRST',
  SolutionIdDescNullsLast = 'solution_id_DESC_NULLS_LAST',
  WorkerIdAsc = 'worker_id_ASC',
  WorkerIdAscNullsFirst = 'worker_id_ASC_NULLS_FIRST',
  WorkerIdAscNullsLast = 'worker_id_ASC_NULLS_LAST',
  WorkerIdDesc = 'worker_id_DESC',
  WorkerIdDescNullsFirst = 'worker_id_DESC_NULLS_FIRST',
  WorkerIdDescNullsLast = 'worker_id_DESC_NULLS_LAST'
}

export type NominatedWorkerNodeHistoryWhereInput = {
  AND?: InputMaybe<Array<NominatedWorkerNodeHistoryWhereInput>>;
  OR?: InputMaybe<Array<NominatedWorkerNodeHistoryWhereInput>>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<SolutionWhereInput>;
  solution_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  worker?: InputMaybe<WorkerWhereInput>;
  worker_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NominatedWorkerNodeOrderByInput {
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  SolutionIdAsc = 'solution_id_ASC',
  SolutionIdAscNullsFirst = 'solution_id_ASC_NULLS_FIRST',
  SolutionIdAscNullsLast = 'solution_id_ASC_NULLS_LAST',
  SolutionIdDesc = 'solution_id_DESC',
  SolutionIdDescNullsFirst = 'solution_id_DESC_NULLS_FIRST',
  SolutionIdDescNullsLast = 'solution_id_DESC_NULLS_LAST',
  WorkerIdAsc = 'worker_id_ASC',
  WorkerIdAscNullsFirst = 'worker_id_ASC_NULLS_FIRST',
  WorkerIdAscNullsLast = 'worker_id_ASC_NULLS_LAST',
  WorkerIdDesc = 'worker_id_DESC',
  WorkerIdDescNullsFirst = 'worker_id_DESC_NULLS_FIRST',
  WorkerIdDescNullsLast = 'worker_id_DESC_NULLS_LAST'
}

export type NominatedWorkerNodeWhereInput = {
  AND?: InputMaybe<Array<NominatedWorkerNodeWhereInput>>;
  OR?: InputMaybe<Array<NominatedWorkerNodeWhereInput>>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<SolutionWhereInput>;
  solution_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  worker?: InputMaybe<WorkerWhereInput>;
  worker_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NominatedWorkerNodesConnection = {
  __typename?: 'NominatedWorkerNodesConnection';
  edges: Array<NominatedWorkerNodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NumberOfSubmissions = {
  __typename?: 'NumberOfSubmissions';
  numberOfSubmissions: Scalars['Float']['output'];
};

export type Operator = {
  __typename?: 'Operator';
  /** Account */
  account: Account;
  /** Account address */
  id: Scalars['String']['output'];
  /** Submitted votes by associated worker accounts */
  votes: Array<Vote>;
};


export type OperatorVotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoteOrderByInput>>;
  where?: InputMaybe<VoteWhereInput>;
};

export type OperatorEdge = {
  __typename?: 'OperatorEdge';
  cursor: Scalars['String']['output'];
  node: Operator;
};

export enum OperatorOrderByInput {
  AccountIdAsc = 'account_id_ASC',
  AccountIdAscNullsFirst = 'account_id_ASC_NULLS_FIRST',
  AccountIdAscNullsLast = 'account_id_ASC_NULLS_LAST',
  AccountIdDesc = 'account_id_DESC',
  AccountIdDescNullsFirst = 'account_id_DESC_NULLS_FIRST',
  AccountIdDescNullsLast = 'account_id_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST'
}

export type OperatorWhereInput = {
  AND?: InputMaybe<Array<OperatorWhereInput>>;
  OR?: InputMaybe<Array<OperatorWhereInput>>;
  account?: InputMaybe<AccountWhereInput>;
  account_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  votes_every?: InputMaybe<VoteWhereInput>;
  votes_none?: InputMaybe<VoteWhereInput>;
  votes_some?: InputMaybe<VoteWhereInput>;
};

export type OperatorsConnection = {
  __typename?: 'OperatorsConnection';
  edges: Array<OperatorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  accountById?: Maybe<Account>;
  accounts: Array<Account>;
  accountsConnection: AccountsConnection;
  nominatedWorkerNodeById?: Maybe<NominatedWorkerNode>;
  nominatedWorkerNodeHistories: Array<NominatedWorkerNodeHistory>;
  nominatedWorkerNodeHistoriesConnection: NominatedWorkerNodeHistoriesConnection;
  nominatedWorkerNodeHistoryById?: Maybe<NominatedWorkerNodeHistory>;
  nominatedWorkerNodes: Array<NominatedWorkerNode>;
  nominatedWorkerNodesConnection: NominatedWorkerNodesConnection;
  operatorById?: Maybe<Operator>;
  operatorNumberOfSubmissions: NumberOfSubmissions;
  operators: Array<Operator>;
  operatorsConnection: OperatorsConnection;
  rewardPeriodById?: Maybe<RewardPeriod>;
  rewardPeriods: Array<RewardPeriod>;
  rewardPeriodsConnection: RewardPeriodsConnection;
  solutionById?: Maybe<Solution>;
  solutionNumberOfSubmissions: Array<SolutionNumberOfSubmissions>;
  solutions: Array<Solution>;
  solutionsConnection: SolutionsConnection;
  squidStatus?: Maybe<SquidStatus>;
  voteById?: Maybe<Vote>;
  voteResultById?: Maybe<VoteResult>;
  voteResults: Array<VoteResult>;
  voteResultsConnection: VoteResultsConnection;
  votes: Array<Vote>;
  votesConnection: VotesConnection;
  votingRoundById?: Maybe<VotingRound>;
  votingRoundNominatedWorkersSnapshotById?: Maybe<VotingRoundNominatedWorkersSnapshot>;
  votingRoundNominatedWorkersSnapshots: Array<VotingRoundNominatedWorkersSnapshot>;
  votingRoundNominatedWorkersSnapshotsConnection: VotingRoundNominatedWorkersSnapshotsConnection;
  votingRounds: Array<VotingRound>;
  votingRoundsConnection: VotingRoundsConnection;
  workerById?: Maybe<Worker>;
  workers: Array<Worker>;
  workersConnection: WorkersConnection;
};


export type QueryAccountByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOrderByInput>>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryAccountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<AccountOrderByInput>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryNominatedWorkerNodeByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryNominatedWorkerNodeHistoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NominatedWorkerNodeHistoryOrderByInput>>;
  where?: InputMaybe<NominatedWorkerNodeHistoryWhereInput>;
};


export type QueryNominatedWorkerNodeHistoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<NominatedWorkerNodeHistoryOrderByInput>;
  where?: InputMaybe<NominatedWorkerNodeHistoryWhereInput>;
};


export type QueryNominatedWorkerNodeHistoryByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryNominatedWorkerNodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NominatedWorkerNodeOrderByInput>>;
  where?: InputMaybe<NominatedWorkerNodeWhereInput>;
};


export type QueryNominatedWorkerNodesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<NominatedWorkerNodeOrderByInput>;
  where?: InputMaybe<NominatedWorkerNodeWhereInput>;
};


export type QueryOperatorByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryOperatorNumberOfSubmissionsArgs = {
  operatorId?: InputMaybe<Scalars['String']['input']>;
  rewardPeriodIndex?: InputMaybe<Scalars['Float']['input']>;
  solutionGroupNamespace?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace?: InputMaybe<Scalars['String']['input']>;
  votingRoundId?: InputMaybe<Scalars['String']['input']>;
  workerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOperatorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorOrderByInput>>;
  where?: InputMaybe<OperatorWhereInput>;
};


export type QueryOperatorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<OperatorOrderByInput>;
  where?: InputMaybe<OperatorWhereInput>;
};


export type QueryRewardPeriodByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryRewardPeriodsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RewardPeriodOrderByInput>>;
  where?: InputMaybe<RewardPeriodWhereInput>;
};


export type QueryRewardPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<RewardPeriodOrderByInput>;
  where?: InputMaybe<RewardPeriodWhereInput>;
};


export type QuerySolutionByIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySolutionNumberOfSubmissionsArgs = {
  rewardPeriodIndex: Scalars['Float']['input'];
  solutionNamespace: Scalars['String']['input'];
  upToBlock: Scalars['Float']['input'];
};


export type QuerySolutionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SolutionOrderByInput>>;
  where?: InputMaybe<SolutionWhereInput>;
};


export type QuerySolutionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<SolutionOrderByInput>;
  where?: InputMaybe<SolutionWhereInput>;
};


export type QueryVoteByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryVoteResultByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryVoteResultsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoteResultOrderByInput>>;
  where?: InputMaybe<VoteResultWhereInput>;
};


export type QueryVoteResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<VoteResultOrderByInput>;
  where?: InputMaybe<VoteResultWhereInput>;
};


export type QueryVotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoteOrderByInput>>;
  where?: InputMaybe<VoteWhereInput>;
};


export type QueryVotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<VoteOrderByInput>;
  where?: InputMaybe<VoteWhereInput>;
};


export type QueryVotingRoundByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryVotingRoundNominatedWorkersSnapshotByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryVotingRoundNominatedWorkersSnapshotsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VotingRoundNominatedWorkersSnapshotOrderByInput>>;
  where?: InputMaybe<VotingRoundNominatedWorkersSnapshotWhereInput>;
};


export type QueryVotingRoundNominatedWorkersSnapshotsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<VotingRoundNominatedWorkersSnapshotOrderByInput>;
  where?: InputMaybe<VotingRoundNominatedWorkersSnapshotWhereInput>;
};


export type QueryVotingRoundsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VotingRoundOrderByInput>>;
  where?: InputMaybe<VotingRoundWhereInput>;
};


export type QueryVotingRoundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<VotingRoundOrderByInput>;
  where?: InputMaybe<VotingRoundWhereInput>;
};


export type QueryWorkerByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkerOrderByInput>>;
  where?: InputMaybe<WorkerWhereInput>;
};


export type QueryWorkersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<WorkerOrderByInput>;
  where?: InputMaybe<WorkerWhereInput>;
};

export type RewardPeriod = {
  __typename?: 'RewardPeriod';
  /** Reward Period Index (stringified) */
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  votes: Array<Vote>;
  votingRounds: Array<Vote>;
};


export type RewardPeriodVotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoteOrderByInput>>;
  where?: InputMaybe<VoteWhereInput>;
};


export type RewardPeriodVotingRoundsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoteOrderByInput>>;
  where?: InputMaybe<VoteWhereInput>;
};

export type RewardPeriodEdge = {
  __typename?: 'RewardPeriodEdge';
  cursor: Scalars['String']['output'];
  node: RewardPeriod;
};

export enum RewardPeriodOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  IndexAsc = 'index_ASC',
  IndexAscNullsFirst = 'index_ASC_NULLS_FIRST',
  IndexAscNullsLast = 'index_ASC_NULLS_LAST',
  IndexDesc = 'index_DESC',
  IndexDescNullsFirst = 'index_DESC_NULLS_FIRST',
  IndexDescNullsLast = 'index_DESC_NULLS_LAST'
}

export type RewardPeriodWhereInput = {
  AND?: InputMaybe<Array<RewardPeriodWhereInput>>;
  OR?: InputMaybe<Array<RewardPeriodWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  index_eq?: InputMaybe<Scalars['Int']['input']>;
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  index_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  index_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  index_not_eq?: InputMaybe<Scalars['Int']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  votes_every?: InputMaybe<VoteWhereInput>;
  votes_none?: InputMaybe<VoteWhereInput>;
  votes_some?: InputMaybe<VoteWhereInput>;
  votingRounds_every?: InputMaybe<VoteWhereInput>;
  votingRounds_none?: InputMaybe<VoteWhereInput>;
  votingRounds_some?: InputMaybe<VoteWhereInput>;
};

export type RewardPeriodsConnection = {
  __typename?: 'RewardPeriodsConnection';
  edges: Array<RewardPeriodEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Solution = {
  __typename?: 'Solution';
  /** ID of solution */
  id: Scalars['String']['output'];
  nominatedWorkerNodes: Array<NominatedWorkerNode>;
  /** Submitted votes for this solution */
  votes: Array<Vote>;
  votingRounds: Array<VotingRound>;
};


export type SolutionNominatedWorkerNodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NominatedWorkerNodeOrderByInput>>;
  where?: InputMaybe<NominatedWorkerNodeWhereInput>;
};


export type SolutionVotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoteOrderByInput>>;
  where?: InputMaybe<VoteWhereInput>;
};


export type SolutionVotingRoundsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VotingRoundOrderByInput>>;
  where?: InputMaybe<VotingRoundWhereInput>;
};

export type SolutionEdge = {
  __typename?: 'SolutionEdge';
  cursor: Scalars['String']['output'];
  node: Solution;
};

export type SolutionNumberOfSubmissions = {
  __typename?: 'SolutionNumberOfSubmissions';
  numberOfSubmissions: Scalars['Float']['output'];
  operator: Scalars['String']['output'];
};

export enum SolutionOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST'
}

export type SolutionWhereInput = {
  AND?: InputMaybe<Array<SolutionWhereInput>>;
  OR?: InputMaybe<Array<SolutionWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  nominatedWorkerNodes_every?: InputMaybe<NominatedWorkerNodeWhereInput>;
  nominatedWorkerNodes_none?: InputMaybe<NominatedWorkerNodeWhereInput>;
  nominatedWorkerNodes_some?: InputMaybe<NominatedWorkerNodeWhereInput>;
  votes_every?: InputMaybe<VoteWhereInput>;
  votes_none?: InputMaybe<VoteWhereInput>;
  votes_some?: InputMaybe<VoteWhereInput>;
  votingRounds_every?: InputMaybe<VotingRoundWhereInput>;
  votingRounds_none?: InputMaybe<VotingRoundWhereInput>;
  votingRounds_some?: InputMaybe<VotingRoundWhereInput>;
};

export type SolutionsConnection = {
  __typename?: 'SolutionsConnection';
  edges: Array<SolutionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SquidStatus = {
  __typename?: 'SquidStatus';
  /** The hash of the last processed finalized block */
  finalizedHash?: Maybe<Scalars['String']['output']>;
  /** The height of the last processed finalized block */
  finalizedHeight?: Maybe<Scalars['Int']['output']>;
  /** The hash of the last processed block */
  hash?: Maybe<Scalars['String']['output']>;
  /** The height of the last processed block */
  height?: Maybe<Scalars['Int']['output']>;
};

export type Vote = {
  __typename?: 'Vote';
  blockHash?: Maybe<Scalars['String']['output']>;
  blockNumber: Scalars['BigInt']['output'];
  extrinsicHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  operator?: Maybe<Operator>;
  rawResult?: Maybe<Scalars['String']['output']>;
  rawVotingRoundId: Scalars['String']['output'];
  result?: Maybe<VoteResult>;
  rewardPeriod?: Maybe<RewardPeriod>;
  solution: Solution;
  votingRound?: Maybe<VotingRound>;
  worker?: Maybe<Worker>;
};

export type VoteEdge = {
  __typename?: 'VoteEdge';
  cursor: Scalars['String']['output'];
  node: Vote;
};

export enum VoteOrderByInput {
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  ExtrinsicHashAsc = 'extrinsicHash_ASC',
  ExtrinsicHashAscNullsFirst = 'extrinsicHash_ASC_NULLS_FIRST',
  ExtrinsicHashAscNullsLast = 'extrinsicHash_ASC_NULLS_LAST',
  ExtrinsicHashDesc = 'extrinsicHash_DESC',
  ExtrinsicHashDescNullsFirst = 'extrinsicHash_DESC_NULLS_FIRST',
  ExtrinsicHashDescNullsLast = 'extrinsicHash_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  OperatorIdAsc = 'operator_id_ASC',
  OperatorIdAscNullsFirst = 'operator_id_ASC_NULLS_FIRST',
  OperatorIdAscNullsLast = 'operator_id_ASC_NULLS_LAST',
  OperatorIdDesc = 'operator_id_DESC',
  OperatorIdDescNullsFirst = 'operator_id_DESC_NULLS_FIRST',
  OperatorIdDescNullsLast = 'operator_id_DESC_NULLS_LAST',
  RawResultAsc = 'rawResult_ASC',
  RawResultAscNullsFirst = 'rawResult_ASC_NULLS_FIRST',
  RawResultAscNullsLast = 'rawResult_ASC_NULLS_LAST',
  RawResultDesc = 'rawResult_DESC',
  RawResultDescNullsFirst = 'rawResult_DESC_NULLS_FIRST',
  RawResultDescNullsLast = 'rawResult_DESC_NULLS_LAST',
  RawVotingRoundIdAsc = 'rawVotingRoundId_ASC',
  RawVotingRoundIdAscNullsFirst = 'rawVotingRoundId_ASC_NULLS_FIRST',
  RawVotingRoundIdAscNullsLast = 'rawVotingRoundId_ASC_NULLS_LAST',
  RawVotingRoundIdDesc = 'rawVotingRoundId_DESC',
  RawVotingRoundIdDescNullsFirst = 'rawVotingRoundId_DESC_NULLS_FIRST',
  RawVotingRoundIdDescNullsLast = 'rawVotingRoundId_DESC_NULLS_LAST',
  ResultBlockNumberAsc = 'result_blockNumber_ASC',
  ResultBlockNumberAscNullsFirst = 'result_blockNumber_ASC_NULLS_FIRST',
  ResultBlockNumberAscNullsLast = 'result_blockNumber_ASC_NULLS_LAST',
  ResultBlockNumberDesc = 'result_blockNumber_DESC',
  ResultBlockNumberDescNullsFirst = 'result_blockNumber_DESC_NULLS_FIRST',
  ResultBlockNumberDescNullsLast = 'result_blockNumber_DESC_NULLS_LAST',
  ResultIdAsc = 'result_id_ASC',
  ResultIdAscNullsFirst = 'result_id_ASC_NULLS_FIRST',
  ResultIdAscNullsLast = 'result_id_ASC_NULLS_LAST',
  ResultIdDesc = 'result_id_DESC',
  ResultIdDescNullsFirst = 'result_id_DESC_NULLS_FIRST',
  ResultIdDescNullsLast = 'result_id_DESC_NULLS_LAST',
  ResultRawVotingRoundIdAsc = 'result_rawVotingRoundId_ASC',
  ResultRawVotingRoundIdAscNullsFirst = 'result_rawVotingRoundId_ASC_NULLS_FIRST',
  ResultRawVotingRoundIdAscNullsLast = 'result_rawVotingRoundId_ASC_NULLS_LAST',
  ResultRawVotingRoundIdDesc = 'result_rawVotingRoundId_DESC',
  ResultRawVotingRoundIdDescNullsFirst = 'result_rawVotingRoundId_DESC_NULLS_FIRST',
  ResultRawVotingRoundIdDescNullsLast = 'result_rawVotingRoundId_DESC_NULLS_LAST',
  ResultResultAsc = 'result_result_ASC',
  ResultResultAscNullsFirst = 'result_result_ASC_NULLS_FIRST',
  ResultResultAscNullsLast = 'result_result_ASC_NULLS_LAST',
  ResultResultDesc = 'result_result_DESC',
  ResultResultDescNullsFirst = 'result_result_DESC_NULLS_FIRST',
  ResultResultDescNullsLast = 'result_result_DESC_NULLS_LAST',
  RewardPeriodIdAsc = 'rewardPeriod_id_ASC',
  RewardPeriodIdAscNullsFirst = 'rewardPeriod_id_ASC_NULLS_FIRST',
  RewardPeriodIdAscNullsLast = 'rewardPeriod_id_ASC_NULLS_LAST',
  RewardPeriodIdDesc = 'rewardPeriod_id_DESC',
  RewardPeriodIdDescNullsFirst = 'rewardPeriod_id_DESC_NULLS_FIRST',
  RewardPeriodIdDescNullsLast = 'rewardPeriod_id_DESC_NULLS_LAST',
  RewardPeriodIndexAsc = 'rewardPeriod_index_ASC',
  RewardPeriodIndexAscNullsFirst = 'rewardPeriod_index_ASC_NULLS_FIRST',
  RewardPeriodIndexAscNullsLast = 'rewardPeriod_index_ASC_NULLS_LAST',
  RewardPeriodIndexDesc = 'rewardPeriod_index_DESC',
  RewardPeriodIndexDescNullsFirst = 'rewardPeriod_index_DESC_NULLS_FIRST',
  RewardPeriodIndexDescNullsLast = 'rewardPeriod_index_DESC_NULLS_LAST',
  SolutionIdAsc = 'solution_id_ASC',
  SolutionIdAscNullsFirst = 'solution_id_ASC_NULLS_FIRST',
  SolutionIdAscNullsLast = 'solution_id_ASC_NULLS_LAST',
  SolutionIdDesc = 'solution_id_DESC',
  SolutionIdDescNullsFirst = 'solution_id_DESC_NULLS_FIRST',
  SolutionIdDescNullsLast = 'solution_id_DESC_NULLS_LAST',
  VotingRoundExpirationBlockAsc = 'votingRound_expirationBlock_ASC',
  VotingRoundExpirationBlockAscNullsFirst = 'votingRound_expirationBlock_ASC_NULLS_FIRST',
  VotingRoundExpirationBlockAscNullsLast = 'votingRound_expirationBlock_ASC_NULLS_LAST',
  VotingRoundExpirationBlockDesc = 'votingRound_expirationBlock_DESC',
  VotingRoundExpirationBlockDescNullsFirst = 'votingRound_expirationBlock_DESC_NULLS_FIRST',
  VotingRoundExpirationBlockDescNullsLast = 'votingRound_expirationBlock_DESC_NULLS_LAST',
  VotingRoundExpiredBlockEventAsc = 'votingRound_expiredBlockEvent_ASC',
  VotingRoundExpiredBlockEventAscNullsFirst = 'votingRound_expiredBlockEvent_ASC_NULLS_FIRST',
  VotingRoundExpiredBlockEventAscNullsLast = 'votingRound_expiredBlockEvent_ASC_NULLS_LAST',
  VotingRoundExpiredBlockEventDesc = 'votingRound_expiredBlockEvent_DESC',
  VotingRoundExpiredBlockEventDescNullsFirst = 'votingRound_expiredBlockEvent_DESC_NULLS_FIRST',
  VotingRoundExpiredBlockEventDescNullsLast = 'votingRound_expiredBlockEvent_DESC_NULLS_LAST',
  VotingRoundExpiredAsc = 'votingRound_expired_ASC',
  VotingRoundExpiredAscNullsFirst = 'votingRound_expired_ASC_NULLS_FIRST',
  VotingRoundExpiredAscNullsLast = 'votingRound_expired_ASC_NULLS_LAST',
  VotingRoundExpiredDesc = 'votingRound_expired_DESC',
  VotingRoundExpiredDescNullsFirst = 'votingRound_expired_DESC_NULLS_FIRST',
  VotingRoundExpiredDescNullsLast = 'votingRound_expired_DESC_NULLS_LAST',
  VotingRoundIdAsc = 'votingRound_id_ASC',
  VotingRoundIdAscNullsFirst = 'votingRound_id_ASC_NULLS_FIRST',
  VotingRoundIdAscNullsLast = 'votingRound_id_ASC_NULLS_LAST',
  VotingRoundIdDesc = 'votingRound_id_DESC',
  VotingRoundIdDescNullsFirst = 'votingRound_id_DESC_NULLS_FIRST',
  VotingRoundIdDescNullsLast = 'votingRound_id_DESC_NULLS_LAST',
  VotingRoundProcessBlockAsc = 'votingRound_processBlock_ASC',
  VotingRoundProcessBlockAscNullsFirst = 'votingRound_processBlock_ASC_NULLS_FIRST',
  VotingRoundProcessBlockAscNullsLast = 'votingRound_processBlock_ASC_NULLS_LAST',
  VotingRoundProcessBlockDesc = 'votingRound_processBlock_DESC',
  VotingRoundProcessBlockDescNullsFirst = 'votingRound_processBlock_DESC_NULLS_FIRST',
  VotingRoundProcessBlockDescNullsLast = 'votingRound_processBlock_DESC_NULLS_LAST',
  VotingRoundResultAsc = 'votingRound_result_ASC',
  VotingRoundResultAscNullsFirst = 'votingRound_result_ASC_NULLS_FIRST',
  VotingRoundResultAscNullsLast = 'votingRound_result_ASC_NULLS_LAST',
  VotingRoundResultDesc = 'votingRound_result_DESC',
  VotingRoundResultDescNullsFirst = 'votingRound_result_DESC_NULLS_FIRST',
  VotingRoundResultDescNullsLast = 'votingRound_result_DESC_NULLS_LAST',
  VotingRoundSettleBlockAsc = 'votingRound_settleBlock_ASC',
  VotingRoundSettleBlockAscNullsFirst = 'votingRound_settleBlock_ASC_NULLS_FIRST',
  VotingRoundSettleBlockAscNullsLast = 'votingRound_settleBlock_ASC_NULLS_LAST',
  VotingRoundSettleBlockDesc = 'votingRound_settleBlock_DESC',
  VotingRoundSettleBlockDescNullsFirst = 'votingRound_settleBlock_DESC_NULLS_FIRST',
  VotingRoundSettleBlockDescNullsLast = 'votingRound_settleBlock_DESC_NULLS_LAST',
  VotingRoundSettledAsc = 'votingRound_settled_ASC',
  VotingRoundSettledAscNullsFirst = 'votingRound_settled_ASC_NULLS_FIRST',
  VotingRoundSettledAscNullsLast = 'votingRound_settled_ASC_NULLS_LAST',
  VotingRoundSettledDesc = 'votingRound_settled_DESC',
  VotingRoundSettledDescNullsFirst = 'votingRound_settled_DESC_NULLS_FIRST',
  VotingRoundSettledDescNullsLast = 'votingRound_settled_DESC_NULLS_LAST',
  VotingRoundStartBlockAsc = 'votingRound_startBlock_ASC',
  VotingRoundStartBlockAscNullsFirst = 'votingRound_startBlock_ASC_NULLS_FIRST',
  VotingRoundStartBlockAscNullsLast = 'votingRound_startBlock_ASC_NULLS_LAST',
  VotingRoundStartBlockDesc = 'votingRound_startBlock_DESC',
  VotingRoundStartBlockDescNullsFirst = 'votingRound_startBlock_DESC_NULLS_FIRST',
  VotingRoundStartBlockDescNullsLast = 'votingRound_startBlock_DESC_NULLS_LAST',
  VotingRoundVotingRoundIdAsc = 'votingRound_votingRoundId_ASC',
  VotingRoundVotingRoundIdAscNullsFirst = 'votingRound_votingRoundId_ASC_NULLS_FIRST',
  VotingRoundVotingRoundIdAscNullsLast = 'votingRound_votingRoundId_ASC_NULLS_LAST',
  VotingRoundVotingRoundIdDesc = 'votingRound_votingRoundId_DESC',
  VotingRoundVotingRoundIdDescNullsFirst = 'votingRound_votingRoundId_DESC_NULLS_FIRST',
  VotingRoundVotingRoundIdDescNullsLast = 'votingRound_votingRoundId_DESC_NULLS_LAST',
  WorkerIdAsc = 'worker_id_ASC',
  WorkerIdAscNullsFirst = 'worker_id_ASC_NULLS_FIRST',
  WorkerIdAscNullsLast = 'worker_id_ASC_NULLS_LAST',
  WorkerIdDesc = 'worker_id_DESC',
  WorkerIdDescNullsFirst = 'worker_id_DESC_NULLS_FIRST',
  WorkerIdDescNullsLast = 'worker_id_DESC_NULLS_LAST'
}

export type VoteResult = {
  __typename?: 'VoteResult';
  blockNumber: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  rawVotingRoundId: Scalars['String']['output'];
  result: Scalars['String']['output'];
  rewardPeriod?: Maybe<RewardPeriod>;
  solution: Solution;
  vote?: Maybe<Vote>;
  votingRound?: Maybe<VotingRound>;
  worker?: Maybe<Worker>;
};

export type VoteResultEdge = {
  __typename?: 'VoteResultEdge';
  cursor: Scalars['String']['output'];
  node: VoteResult;
};

export enum VoteResultOrderByInput {
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  RawVotingRoundIdAsc = 'rawVotingRoundId_ASC',
  RawVotingRoundIdAscNullsFirst = 'rawVotingRoundId_ASC_NULLS_FIRST',
  RawVotingRoundIdAscNullsLast = 'rawVotingRoundId_ASC_NULLS_LAST',
  RawVotingRoundIdDesc = 'rawVotingRoundId_DESC',
  RawVotingRoundIdDescNullsFirst = 'rawVotingRoundId_DESC_NULLS_FIRST',
  RawVotingRoundIdDescNullsLast = 'rawVotingRoundId_DESC_NULLS_LAST',
  ResultAsc = 'result_ASC',
  ResultAscNullsFirst = 'result_ASC_NULLS_FIRST',
  ResultAscNullsLast = 'result_ASC_NULLS_LAST',
  ResultDesc = 'result_DESC',
  ResultDescNullsFirst = 'result_DESC_NULLS_FIRST',
  ResultDescNullsLast = 'result_DESC_NULLS_LAST',
  RewardPeriodIdAsc = 'rewardPeriod_id_ASC',
  RewardPeriodIdAscNullsFirst = 'rewardPeriod_id_ASC_NULLS_FIRST',
  RewardPeriodIdAscNullsLast = 'rewardPeriod_id_ASC_NULLS_LAST',
  RewardPeriodIdDesc = 'rewardPeriod_id_DESC',
  RewardPeriodIdDescNullsFirst = 'rewardPeriod_id_DESC_NULLS_FIRST',
  RewardPeriodIdDescNullsLast = 'rewardPeriod_id_DESC_NULLS_LAST',
  RewardPeriodIndexAsc = 'rewardPeriod_index_ASC',
  RewardPeriodIndexAscNullsFirst = 'rewardPeriod_index_ASC_NULLS_FIRST',
  RewardPeriodIndexAscNullsLast = 'rewardPeriod_index_ASC_NULLS_LAST',
  RewardPeriodIndexDesc = 'rewardPeriod_index_DESC',
  RewardPeriodIndexDescNullsFirst = 'rewardPeriod_index_DESC_NULLS_FIRST',
  RewardPeriodIndexDescNullsLast = 'rewardPeriod_index_DESC_NULLS_LAST',
  SolutionIdAsc = 'solution_id_ASC',
  SolutionIdAscNullsFirst = 'solution_id_ASC_NULLS_FIRST',
  SolutionIdAscNullsLast = 'solution_id_ASC_NULLS_LAST',
  SolutionIdDesc = 'solution_id_DESC',
  SolutionIdDescNullsFirst = 'solution_id_DESC_NULLS_FIRST',
  SolutionIdDescNullsLast = 'solution_id_DESC_NULLS_LAST',
  VoteBlockHashAsc = 'vote_blockHash_ASC',
  VoteBlockHashAscNullsFirst = 'vote_blockHash_ASC_NULLS_FIRST',
  VoteBlockHashAscNullsLast = 'vote_blockHash_ASC_NULLS_LAST',
  VoteBlockHashDesc = 'vote_blockHash_DESC',
  VoteBlockHashDescNullsFirst = 'vote_blockHash_DESC_NULLS_FIRST',
  VoteBlockHashDescNullsLast = 'vote_blockHash_DESC_NULLS_LAST',
  VoteBlockNumberAsc = 'vote_blockNumber_ASC',
  VoteBlockNumberAscNullsFirst = 'vote_blockNumber_ASC_NULLS_FIRST',
  VoteBlockNumberAscNullsLast = 'vote_blockNumber_ASC_NULLS_LAST',
  VoteBlockNumberDesc = 'vote_blockNumber_DESC',
  VoteBlockNumberDescNullsFirst = 'vote_blockNumber_DESC_NULLS_FIRST',
  VoteBlockNumberDescNullsLast = 'vote_blockNumber_DESC_NULLS_LAST',
  VoteExtrinsicHashAsc = 'vote_extrinsicHash_ASC',
  VoteExtrinsicHashAscNullsFirst = 'vote_extrinsicHash_ASC_NULLS_FIRST',
  VoteExtrinsicHashAscNullsLast = 'vote_extrinsicHash_ASC_NULLS_LAST',
  VoteExtrinsicHashDesc = 'vote_extrinsicHash_DESC',
  VoteExtrinsicHashDescNullsFirst = 'vote_extrinsicHash_DESC_NULLS_FIRST',
  VoteExtrinsicHashDescNullsLast = 'vote_extrinsicHash_DESC_NULLS_LAST',
  VoteIdAsc = 'vote_id_ASC',
  VoteIdAscNullsFirst = 'vote_id_ASC_NULLS_FIRST',
  VoteIdAscNullsLast = 'vote_id_ASC_NULLS_LAST',
  VoteIdDesc = 'vote_id_DESC',
  VoteIdDescNullsFirst = 'vote_id_DESC_NULLS_FIRST',
  VoteIdDescNullsLast = 'vote_id_DESC_NULLS_LAST',
  VoteRawResultAsc = 'vote_rawResult_ASC',
  VoteRawResultAscNullsFirst = 'vote_rawResult_ASC_NULLS_FIRST',
  VoteRawResultAscNullsLast = 'vote_rawResult_ASC_NULLS_LAST',
  VoteRawResultDesc = 'vote_rawResult_DESC',
  VoteRawResultDescNullsFirst = 'vote_rawResult_DESC_NULLS_FIRST',
  VoteRawResultDescNullsLast = 'vote_rawResult_DESC_NULLS_LAST',
  VoteRawVotingRoundIdAsc = 'vote_rawVotingRoundId_ASC',
  VoteRawVotingRoundIdAscNullsFirst = 'vote_rawVotingRoundId_ASC_NULLS_FIRST',
  VoteRawVotingRoundIdAscNullsLast = 'vote_rawVotingRoundId_ASC_NULLS_LAST',
  VoteRawVotingRoundIdDesc = 'vote_rawVotingRoundId_DESC',
  VoteRawVotingRoundIdDescNullsFirst = 'vote_rawVotingRoundId_DESC_NULLS_FIRST',
  VoteRawVotingRoundIdDescNullsLast = 'vote_rawVotingRoundId_DESC_NULLS_LAST',
  VotingRoundExpirationBlockAsc = 'votingRound_expirationBlock_ASC',
  VotingRoundExpirationBlockAscNullsFirst = 'votingRound_expirationBlock_ASC_NULLS_FIRST',
  VotingRoundExpirationBlockAscNullsLast = 'votingRound_expirationBlock_ASC_NULLS_LAST',
  VotingRoundExpirationBlockDesc = 'votingRound_expirationBlock_DESC',
  VotingRoundExpirationBlockDescNullsFirst = 'votingRound_expirationBlock_DESC_NULLS_FIRST',
  VotingRoundExpirationBlockDescNullsLast = 'votingRound_expirationBlock_DESC_NULLS_LAST',
  VotingRoundExpiredBlockEventAsc = 'votingRound_expiredBlockEvent_ASC',
  VotingRoundExpiredBlockEventAscNullsFirst = 'votingRound_expiredBlockEvent_ASC_NULLS_FIRST',
  VotingRoundExpiredBlockEventAscNullsLast = 'votingRound_expiredBlockEvent_ASC_NULLS_LAST',
  VotingRoundExpiredBlockEventDesc = 'votingRound_expiredBlockEvent_DESC',
  VotingRoundExpiredBlockEventDescNullsFirst = 'votingRound_expiredBlockEvent_DESC_NULLS_FIRST',
  VotingRoundExpiredBlockEventDescNullsLast = 'votingRound_expiredBlockEvent_DESC_NULLS_LAST',
  VotingRoundExpiredAsc = 'votingRound_expired_ASC',
  VotingRoundExpiredAscNullsFirst = 'votingRound_expired_ASC_NULLS_FIRST',
  VotingRoundExpiredAscNullsLast = 'votingRound_expired_ASC_NULLS_LAST',
  VotingRoundExpiredDesc = 'votingRound_expired_DESC',
  VotingRoundExpiredDescNullsFirst = 'votingRound_expired_DESC_NULLS_FIRST',
  VotingRoundExpiredDescNullsLast = 'votingRound_expired_DESC_NULLS_LAST',
  VotingRoundIdAsc = 'votingRound_id_ASC',
  VotingRoundIdAscNullsFirst = 'votingRound_id_ASC_NULLS_FIRST',
  VotingRoundIdAscNullsLast = 'votingRound_id_ASC_NULLS_LAST',
  VotingRoundIdDesc = 'votingRound_id_DESC',
  VotingRoundIdDescNullsFirst = 'votingRound_id_DESC_NULLS_FIRST',
  VotingRoundIdDescNullsLast = 'votingRound_id_DESC_NULLS_LAST',
  VotingRoundProcessBlockAsc = 'votingRound_processBlock_ASC',
  VotingRoundProcessBlockAscNullsFirst = 'votingRound_processBlock_ASC_NULLS_FIRST',
  VotingRoundProcessBlockAscNullsLast = 'votingRound_processBlock_ASC_NULLS_LAST',
  VotingRoundProcessBlockDesc = 'votingRound_processBlock_DESC',
  VotingRoundProcessBlockDescNullsFirst = 'votingRound_processBlock_DESC_NULLS_FIRST',
  VotingRoundProcessBlockDescNullsLast = 'votingRound_processBlock_DESC_NULLS_LAST',
  VotingRoundResultAsc = 'votingRound_result_ASC',
  VotingRoundResultAscNullsFirst = 'votingRound_result_ASC_NULLS_FIRST',
  VotingRoundResultAscNullsLast = 'votingRound_result_ASC_NULLS_LAST',
  VotingRoundResultDesc = 'votingRound_result_DESC',
  VotingRoundResultDescNullsFirst = 'votingRound_result_DESC_NULLS_FIRST',
  VotingRoundResultDescNullsLast = 'votingRound_result_DESC_NULLS_LAST',
  VotingRoundSettleBlockAsc = 'votingRound_settleBlock_ASC',
  VotingRoundSettleBlockAscNullsFirst = 'votingRound_settleBlock_ASC_NULLS_FIRST',
  VotingRoundSettleBlockAscNullsLast = 'votingRound_settleBlock_ASC_NULLS_LAST',
  VotingRoundSettleBlockDesc = 'votingRound_settleBlock_DESC',
  VotingRoundSettleBlockDescNullsFirst = 'votingRound_settleBlock_DESC_NULLS_FIRST',
  VotingRoundSettleBlockDescNullsLast = 'votingRound_settleBlock_DESC_NULLS_LAST',
  VotingRoundSettledAsc = 'votingRound_settled_ASC',
  VotingRoundSettledAscNullsFirst = 'votingRound_settled_ASC_NULLS_FIRST',
  VotingRoundSettledAscNullsLast = 'votingRound_settled_ASC_NULLS_LAST',
  VotingRoundSettledDesc = 'votingRound_settled_DESC',
  VotingRoundSettledDescNullsFirst = 'votingRound_settled_DESC_NULLS_FIRST',
  VotingRoundSettledDescNullsLast = 'votingRound_settled_DESC_NULLS_LAST',
  VotingRoundStartBlockAsc = 'votingRound_startBlock_ASC',
  VotingRoundStartBlockAscNullsFirst = 'votingRound_startBlock_ASC_NULLS_FIRST',
  VotingRoundStartBlockAscNullsLast = 'votingRound_startBlock_ASC_NULLS_LAST',
  VotingRoundStartBlockDesc = 'votingRound_startBlock_DESC',
  VotingRoundStartBlockDescNullsFirst = 'votingRound_startBlock_DESC_NULLS_FIRST',
  VotingRoundStartBlockDescNullsLast = 'votingRound_startBlock_DESC_NULLS_LAST',
  VotingRoundVotingRoundIdAsc = 'votingRound_votingRoundId_ASC',
  VotingRoundVotingRoundIdAscNullsFirst = 'votingRound_votingRoundId_ASC_NULLS_FIRST',
  VotingRoundVotingRoundIdAscNullsLast = 'votingRound_votingRoundId_ASC_NULLS_LAST',
  VotingRoundVotingRoundIdDesc = 'votingRound_votingRoundId_DESC',
  VotingRoundVotingRoundIdDescNullsFirst = 'votingRound_votingRoundId_DESC_NULLS_FIRST',
  VotingRoundVotingRoundIdDescNullsLast = 'votingRound_votingRoundId_DESC_NULLS_LAST',
  WorkerIdAsc = 'worker_id_ASC',
  WorkerIdAscNullsFirst = 'worker_id_ASC_NULLS_FIRST',
  WorkerIdAscNullsLast = 'worker_id_ASC_NULLS_LAST',
  WorkerIdDesc = 'worker_id_DESC',
  WorkerIdDescNullsFirst = 'worker_id_DESC_NULLS_FIRST',
  WorkerIdDescNullsLast = 'worker_id_DESC_NULLS_LAST'
}

export type VoteResultWhereInput = {
  AND?: InputMaybe<Array<VoteResultWhereInput>>;
  OR?: InputMaybe<Array<VoteResultWhereInput>>;
  blockNumber_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_contains?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_endsWith?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_eq?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_gt?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_gte?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rawVotingRoundId_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rawVotingRoundId_lt?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_lte?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_eq?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rawVotingRoundId_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_startsWith?: InputMaybe<Scalars['String']['input']>;
  result_contains?: InputMaybe<Scalars['String']['input']>;
  result_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  result_endsWith?: InputMaybe<Scalars['String']['input']>;
  result_eq?: InputMaybe<Scalars['String']['input']>;
  result_gt?: InputMaybe<Scalars['String']['input']>;
  result_gte?: InputMaybe<Scalars['String']['input']>;
  result_in?: InputMaybe<Array<Scalars['String']['input']>>;
  result_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  result_lt?: InputMaybe<Scalars['String']['input']>;
  result_lte?: InputMaybe<Scalars['String']['input']>;
  result_not_contains?: InputMaybe<Scalars['String']['input']>;
  result_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  result_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  result_not_eq?: InputMaybe<Scalars['String']['input']>;
  result_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  result_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  result_startsWith?: InputMaybe<Scalars['String']['input']>;
  rewardPeriod?: InputMaybe<RewardPeriodWhereInput>;
  rewardPeriod_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  solution?: InputMaybe<SolutionWhereInput>;
  solution_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  vote?: InputMaybe<VoteWhereInput>;
  vote_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  votingRound?: InputMaybe<VotingRoundWhereInput>;
  votingRound_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  worker?: InputMaybe<WorkerWhereInput>;
  worker_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VoteResultsConnection = {
  __typename?: 'VoteResultsConnection';
  edges: Array<VoteResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VoteWhereInput = {
  AND?: InputMaybe<Array<VoteWhereInput>>;
  OR?: InputMaybe<Array<VoteWhereInput>>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  extrinsicHash_contains?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_eq?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_gt?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_gte?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extrinsicHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  extrinsicHash_lt?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_lte?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extrinsicHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<OperatorWhereInput>;
  operator_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rawResult_contains?: InputMaybe<Scalars['String']['input']>;
  rawResult_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  rawResult_endsWith?: InputMaybe<Scalars['String']['input']>;
  rawResult_eq?: InputMaybe<Scalars['String']['input']>;
  rawResult_gt?: InputMaybe<Scalars['String']['input']>;
  rawResult_gte?: InputMaybe<Scalars['String']['input']>;
  rawResult_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rawResult_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rawResult_lt?: InputMaybe<Scalars['String']['input']>;
  rawResult_lte?: InputMaybe<Scalars['String']['input']>;
  rawResult_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawResult_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  rawResult_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  rawResult_not_eq?: InputMaybe<Scalars['String']['input']>;
  rawResult_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rawResult_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  rawResult_startsWith?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_contains?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_endsWith?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_eq?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_gt?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_gte?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rawVotingRoundId_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rawVotingRoundId_lt?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_lte?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_eq?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rawVotingRoundId_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  rawVotingRoundId_startsWith?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<VoteResultWhereInput>;
  result_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rewardPeriod?: InputMaybe<RewardPeriodWhereInput>;
  rewardPeriod_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  solution?: InputMaybe<SolutionWhereInput>;
  solution_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  votingRound?: InputMaybe<VotingRoundWhereInput>;
  votingRound_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  worker?: InputMaybe<WorkerWhereInput>;
  worker_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VotesConnection = {
  __typename?: 'VotesConnection';
  edges: Array<VoteEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VotingRound = {
  __typename?: 'VotingRound';
  expirationBlock?: Maybe<Scalars['BigInt']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  expiredBlockEvent?: Maybe<Scalars['BigInt']['output']>;
  /** ID of voting round. Consists of ${blockId}-${votingRoundId}-${solutionId} */
  id: Scalars['String']['output'];
  nominatedWorkers: Array<VotingRoundNominatedWorkersSnapshot>;
  processBlock?: Maybe<Scalars['BigInt']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  rewardPeriod: RewardPeriod;
  settleBlock?: Maybe<Scalars['BigInt']['output']>;
  settled?: Maybe<Scalars['Boolean']['output']>;
  solution: Solution;
  startBlock?: Maybe<Scalars['BigInt']['output']>;
  votes: Array<Vote>;
  votingRoundId: Scalars['String']['output'];
  who?: Maybe<Account>;
};


export type VotingRoundNominatedWorkersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VotingRoundNominatedWorkersSnapshotOrderByInput>>;
  where?: InputMaybe<VotingRoundNominatedWorkersSnapshotWhereInput>;
};


export type VotingRoundVotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoteOrderByInput>>;
  where?: InputMaybe<VoteWhereInput>;
};

export type VotingRoundEdge = {
  __typename?: 'VotingRoundEdge';
  cursor: Scalars['String']['output'];
  node: VotingRound;
};

export type VotingRoundNominatedWorkersSnapshot = {
  __typename?: 'VotingRoundNominatedWorkersSnapshot';
  /** ID of nominated worker snapshot */
  id: Scalars['String']['output'];
  votingRound: VotingRound;
  worker: Worker;
};

export type VotingRoundNominatedWorkersSnapshotEdge = {
  __typename?: 'VotingRoundNominatedWorkersSnapshotEdge';
  cursor: Scalars['String']['output'];
  node: VotingRoundNominatedWorkersSnapshot;
};

export enum VotingRoundNominatedWorkersSnapshotOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  VotingRoundExpirationBlockAsc = 'votingRound_expirationBlock_ASC',
  VotingRoundExpirationBlockAscNullsFirst = 'votingRound_expirationBlock_ASC_NULLS_FIRST',
  VotingRoundExpirationBlockAscNullsLast = 'votingRound_expirationBlock_ASC_NULLS_LAST',
  VotingRoundExpirationBlockDesc = 'votingRound_expirationBlock_DESC',
  VotingRoundExpirationBlockDescNullsFirst = 'votingRound_expirationBlock_DESC_NULLS_FIRST',
  VotingRoundExpirationBlockDescNullsLast = 'votingRound_expirationBlock_DESC_NULLS_LAST',
  VotingRoundExpiredBlockEventAsc = 'votingRound_expiredBlockEvent_ASC',
  VotingRoundExpiredBlockEventAscNullsFirst = 'votingRound_expiredBlockEvent_ASC_NULLS_FIRST',
  VotingRoundExpiredBlockEventAscNullsLast = 'votingRound_expiredBlockEvent_ASC_NULLS_LAST',
  VotingRoundExpiredBlockEventDesc = 'votingRound_expiredBlockEvent_DESC',
  VotingRoundExpiredBlockEventDescNullsFirst = 'votingRound_expiredBlockEvent_DESC_NULLS_FIRST',
  VotingRoundExpiredBlockEventDescNullsLast = 'votingRound_expiredBlockEvent_DESC_NULLS_LAST',
  VotingRoundExpiredAsc = 'votingRound_expired_ASC',
  VotingRoundExpiredAscNullsFirst = 'votingRound_expired_ASC_NULLS_FIRST',
  VotingRoundExpiredAscNullsLast = 'votingRound_expired_ASC_NULLS_LAST',
  VotingRoundExpiredDesc = 'votingRound_expired_DESC',
  VotingRoundExpiredDescNullsFirst = 'votingRound_expired_DESC_NULLS_FIRST',
  VotingRoundExpiredDescNullsLast = 'votingRound_expired_DESC_NULLS_LAST',
  VotingRoundIdAsc = 'votingRound_id_ASC',
  VotingRoundIdAscNullsFirst = 'votingRound_id_ASC_NULLS_FIRST',
  VotingRoundIdAscNullsLast = 'votingRound_id_ASC_NULLS_LAST',
  VotingRoundIdDesc = 'votingRound_id_DESC',
  VotingRoundIdDescNullsFirst = 'votingRound_id_DESC_NULLS_FIRST',
  VotingRoundIdDescNullsLast = 'votingRound_id_DESC_NULLS_LAST',
  VotingRoundProcessBlockAsc = 'votingRound_processBlock_ASC',
  VotingRoundProcessBlockAscNullsFirst = 'votingRound_processBlock_ASC_NULLS_FIRST',
  VotingRoundProcessBlockAscNullsLast = 'votingRound_processBlock_ASC_NULLS_LAST',
  VotingRoundProcessBlockDesc = 'votingRound_processBlock_DESC',
  VotingRoundProcessBlockDescNullsFirst = 'votingRound_processBlock_DESC_NULLS_FIRST',
  VotingRoundProcessBlockDescNullsLast = 'votingRound_processBlock_DESC_NULLS_LAST',
  VotingRoundResultAsc = 'votingRound_result_ASC',
  VotingRoundResultAscNullsFirst = 'votingRound_result_ASC_NULLS_FIRST',
  VotingRoundResultAscNullsLast = 'votingRound_result_ASC_NULLS_LAST',
  VotingRoundResultDesc = 'votingRound_result_DESC',
  VotingRoundResultDescNullsFirst = 'votingRound_result_DESC_NULLS_FIRST',
  VotingRoundResultDescNullsLast = 'votingRound_result_DESC_NULLS_LAST',
  VotingRoundSettleBlockAsc = 'votingRound_settleBlock_ASC',
  VotingRoundSettleBlockAscNullsFirst = 'votingRound_settleBlock_ASC_NULLS_FIRST',
  VotingRoundSettleBlockAscNullsLast = 'votingRound_settleBlock_ASC_NULLS_LAST',
  VotingRoundSettleBlockDesc = 'votingRound_settleBlock_DESC',
  VotingRoundSettleBlockDescNullsFirst = 'votingRound_settleBlock_DESC_NULLS_FIRST',
  VotingRoundSettleBlockDescNullsLast = 'votingRound_settleBlock_DESC_NULLS_LAST',
  VotingRoundSettledAsc = 'votingRound_settled_ASC',
  VotingRoundSettledAscNullsFirst = 'votingRound_settled_ASC_NULLS_FIRST',
  VotingRoundSettledAscNullsLast = 'votingRound_settled_ASC_NULLS_LAST',
  VotingRoundSettledDesc = 'votingRound_settled_DESC',
  VotingRoundSettledDescNullsFirst = 'votingRound_settled_DESC_NULLS_FIRST',
  VotingRoundSettledDescNullsLast = 'votingRound_settled_DESC_NULLS_LAST',
  VotingRoundStartBlockAsc = 'votingRound_startBlock_ASC',
  VotingRoundStartBlockAscNullsFirst = 'votingRound_startBlock_ASC_NULLS_FIRST',
  VotingRoundStartBlockAscNullsLast = 'votingRound_startBlock_ASC_NULLS_LAST',
  VotingRoundStartBlockDesc = 'votingRound_startBlock_DESC',
  VotingRoundStartBlockDescNullsFirst = 'votingRound_startBlock_DESC_NULLS_FIRST',
  VotingRoundStartBlockDescNullsLast = 'votingRound_startBlock_DESC_NULLS_LAST',
  VotingRoundVotingRoundIdAsc = 'votingRound_votingRoundId_ASC',
  VotingRoundVotingRoundIdAscNullsFirst = 'votingRound_votingRoundId_ASC_NULLS_FIRST',
  VotingRoundVotingRoundIdAscNullsLast = 'votingRound_votingRoundId_ASC_NULLS_LAST',
  VotingRoundVotingRoundIdDesc = 'votingRound_votingRoundId_DESC',
  VotingRoundVotingRoundIdDescNullsFirst = 'votingRound_votingRoundId_DESC_NULLS_FIRST',
  VotingRoundVotingRoundIdDescNullsLast = 'votingRound_votingRoundId_DESC_NULLS_LAST',
  WorkerIdAsc = 'worker_id_ASC',
  WorkerIdAscNullsFirst = 'worker_id_ASC_NULLS_FIRST',
  WorkerIdAscNullsLast = 'worker_id_ASC_NULLS_LAST',
  WorkerIdDesc = 'worker_id_DESC',
  WorkerIdDescNullsFirst = 'worker_id_DESC_NULLS_FIRST',
  WorkerIdDescNullsLast = 'worker_id_DESC_NULLS_LAST'
}

export type VotingRoundNominatedWorkersSnapshotWhereInput = {
  AND?: InputMaybe<Array<VotingRoundNominatedWorkersSnapshotWhereInput>>;
  OR?: InputMaybe<Array<VotingRoundNominatedWorkersSnapshotWhereInput>>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  votingRound?: InputMaybe<VotingRoundWhereInput>;
  votingRound_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  worker?: InputMaybe<WorkerWhereInput>;
  worker_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VotingRoundNominatedWorkersSnapshotsConnection = {
  __typename?: 'VotingRoundNominatedWorkersSnapshotsConnection';
  edges: Array<VotingRoundNominatedWorkersSnapshotEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum VotingRoundOrderByInput {
  ExpirationBlockAsc = 'expirationBlock_ASC',
  ExpirationBlockAscNullsFirst = 'expirationBlock_ASC_NULLS_FIRST',
  ExpirationBlockAscNullsLast = 'expirationBlock_ASC_NULLS_LAST',
  ExpirationBlockDesc = 'expirationBlock_DESC',
  ExpirationBlockDescNullsFirst = 'expirationBlock_DESC_NULLS_FIRST',
  ExpirationBlockDescNullsLast = 'expirationBlock_DESC_NULLS_LAST',
  ExpiredBlockEventAsc = 'expiredBlockEvent_ASC',
  ExpiredBlockEventAscNullsFirst = 'expiredBlockEvent_ASC_NULLS_FIRST',
  ExpiredBlockEventAscNullsLast = 'expiredBlockEvent_ASC_NULLS_LAST',
  ExpiredBlockEventDesc = 'expiredBlockEvent_DESC',
  ExpiredBlockEventDescNullsFirst = 'expiredBlockEvent_DESC_NULLS_FIRST',
  ExpiredBlockEventDescNullsLast = 'expiredBlockEvent_DESC_NULLS_LAST',
  ExpiredAsc = 'expired_ASC',
  ExpiredAscNullsFirst = 'expired_ASC_NULLS_FIRST',
  ExpiredAscNullsLast = 'expired_ASC_NULLS_LAST',
  ExpiredDesc = 'expired_DESC',
  ExpiredDescNullsFirst = 'expired_DESC_NULLS_FIRST',
  ExpiredDescNullsLast = 'expired_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  ProcessBlockAsc = 'processBlock_ASC',
  ProcessBlockAscNullsFirst = 'processBlock_ASC_NULLS_FIRST',
  ProcessBlockAscNullsLast = 'processBlock_ASC_NULLS_LAST',
  ProcessBlockDesc = 'processBlock_DESC',
  ProcessBlockDescNullsFirst = 'processBlock_DESC_NULLS_FIRST',
  ProcessBlockDescNullsLast = 'processBlock_DESC_NULLS_LAST',
  ResultAsc = 'result_ASC',
  ResultAscNullsFirst = 'result_ASC_NULLS_FIRST',
  ResultAscNullsLast = 'result_ASC_NULLS_LAST',
  ResultDesc = 'result_DESC',
  ResultDescNullsFirst = 'result_DESC_NULLS_FIRST',
  ResultDescNullsLast = 'result_DESC_NULLS_LAST',
  RewardPeriodIdAsc = 'rewardPeriod_id_ASC',
  RewardPeriodIdAscNullsFirst = 'rewardPeriod_id_ASC_NULLS_FIRST',
  RewardPeriodIdAscNullsLast = 'rewardPeriod_id_ASC_NULLS_LAST',
  RewardPeriodIdDesc = 'rewardPeriod_id_DESC',
  RewardPeriodIdDescNullsFirst = 'rewardPeriod_id_DESC_NULLS_FIRST',
  RewardPeriodIdDescNullsLast = 'rewardPeriod_id_DESC_NULLS_LAST',
  RewardPeriodIndexAsc = 'rewardPeriod_index_ASC',
  RewardPeriodIndexAscNullsFirst = 'rewardPeriod_index_ASC_NULLS_FIRST',
  RewardPeriodIndexAscNullsLast = 'rewardPeriod_index_ASC_NULLS_LAST',
  RewardPeriodIndexDesc = 'rewardPeriod_index_DESC',
  RewardPeriodIndexDescNullsFirst = 'rewardPeriod_index_DESC_NULLS_FIRST',
  RewardPeriodIndexDescNullsLast = 'rewardPeriod_index_DESC_NULLS_LAST',
  SettleBlockAsc = 'settleBlock_ASC',
  SettleBlockAscNullsFirst = 'settleBlock_ASC_NULLS_FIRST',
  SettleBlockAscNullsLast = 'settleBlock_ASC_NULLS_LAST',
  SettleBlockDesc = 'settleBlock_DESC',
  SettleBlockDescNullsFirst = 'settleBlock_DESC_NULLS_FIRST',
  SettleBlockDescNullsLast = 'settleBlock_DESC_NULLS_LAST',
  SettledAsc = 'settled_ASC',
  SettledAscNullsFirst = 'settled_ASC_NULLS_FIRST',
  SettledAscNullsLast = 'settled_ASC_NULLS_LAST',
  SettledDesc = 'settled_DESC',
  SettledDescNullsFirst = 'settled_DESC_NULLS_FIRST',
  SettledDescNullsLast = 'settled_DESC_NULLS_LAST',
  SolutionIdAsc = 'solution_id_ASC',
  SolutionIdAscNullsFirst = 'solution_id_ASC_NULLS_FIRST',
  SolutionIdAscNullsLast = 'solution_id_ASC_NULLS_LAST',
  SolutionIdDesc = 'solution_id_DESC',
  SolutionIdDescNullsFirst = 'solution_id_DESC_NULLS_FIRST',
  SolutionIdDescNullsLast = 'solution_id_DESC_NULLS_LAST',
  StartBlockAsc = 'startBlock_ASC',
  StartBlockAscNullsFirst = 'startBlock_ASC_NULLS_FIRST',
  StartBlockAscNullsLast = 'startBlock_ASC_NULLS_LAST',
  StartBlockDesc = 'startBlock_DESC',
  StartBlockDescNullsFirst = 'startBlock_DESC_NULLS_FIRST',
  StartBlockDescNullsLast = 'startBlock_DESC_NULLS_LAST',
  VotingRoundIdAsc = 'votingRoundId_ASC',
  VotingRoundIdAscNullsFirst = 'votingRoundId_ASC_NULLS_FIRST',
  VotingRoundIdAscNullsLast = 'votingRoundId_ASC_NULLS_LAST',
  VotingRoundIdDesc = 'votingRoundId_DESC',
  VotingRoundIdDescNullsFirst = 'votingRoundId_DESC_NULLS_FIRST',
  VotingRoundIdDescNullsLast = 'votingRoundId_DESC_NULLS_LAST',
  WhoIdAsc = 'who_id_ASC',
  WhoIdAscNullsFirst = 'who_id_ASC_NULLS_FIRST',
  WhoIdAscNullsLast = 'who_id_ASC_NULLS_LAST',
  WhoIdDesc = 'who_id_DESC',
  WhoIdDescNullsFirst = 'who_id_DESC_NULLS_FIRST',
  WhoIdDescNullsLast = 'who_id_DESC_NULLS_LAST'
}

export type VotingRoundWhereInput = {
  AND?: InputMaybe<Array<VotingRoundWhereInput>>;
  OR?: InputMaybe<Array<VotingRoundWhereInput>>;
  expirationBlock_eq?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expirationBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  expirationBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  expirationBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expiredBlockEvent_eq?: InputMaybe<Scalars['BigInt']['input']>;
  expiredBlockEvent_gt?: InputMaybe<Scalars['BigInt']['input']>;
  expiredBlockEvent_gte?: InputMaybe<Scalars['BigInt']['input']>;
  expiredBlockEvent_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expiredBlockEvent_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  expiredBlockEvent_lt?: InputMaybe<Scalars['BigInt']['input']>;
  expiredBlockEvent_lte?: InputMaybe<Scalars['BigInt']['input']>;
  expiredBlockEvent_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  expiredBlockEvent_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expired_eq?: InputMaybe<Scalars['Boolean']['input']>;
  expired_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  expired_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  nominatedWorkers_every?: InputMaybe<VotingRoundNominatedWorkersSnapshotWhereInput>;
  nominatedWorkers_none?: InputMaybe<VotingRoundNominatedWorkersSnapshotWhereInput>;
  nominatedWorkers_some?: InputMaybe<VotingRoundNominatedWorkersSnapshotWhereInput>;
  processBlock_eq?: InputMaybe<Scalars['BigInt']['input']>;
  processBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  processBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  processBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  processBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  processBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  processBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  processBlock_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  processBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  result_contains?: InputMaybe<Scalars['String']['input']>;
  result_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  result_endsWith?: InputMaybe<Scalars['String']['input']>;
  result_eq?: InputMaybe<Scalars['String']['input']>;
  result_gt?: InputMaybe<Scalars['String']['input']>;
  result_gte?: InputMaybe<Scalars['String']['input']>;
  result_in?: InputMaybe<Array<Scalars['String']['input']>>;
  result_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  result_lt?: InputMaybe<Scalars['String']['input']>;
  result_lte?: InputMaybe<Scalars['String']['input']>;
  result_not_contains?: InputMaybe<Scalars['String']['input']>;
  result_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  result_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  result_not_eq?: InputMaybe<Scalars['String']['input']>;
  result_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  result_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  result_startsWith?: InputMaybe<Scalars['String']['input']>;
  rewardPeriod?: InputMaybe<RewardPeriodWhereInput>;
  rewardPeriod_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  settleBlock_eq?: InputMaybe<Scalars['BigInt']['input']>;
  settleBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  settleBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  settleBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  settleBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  settleBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  settleBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  settleBlock_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  settleBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  settled_eq?: InputMaybe<Scalars['Boolean']['input']>;
  settled_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  settled_not_eq?: InputMaybe<Scalars['Boolean']['input']>;
  solution?: InputMaybe<SolutionWhereInput>;
  solution_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  startBlock_eq?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startBlock_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  startBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  votes_every?: InputMaybe<VoteWhereInput>;
  votes_none?: InputMaybe<VoteWhereInput>;
  votes_some?: InputMaybe<VoteWhereInput>;
  votingRoundId_contains?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_endsWith?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_eq?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_gt?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_gte?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  votingRoundId_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  votingRoundId_lt?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_lte?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_contains?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_eq?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  votingRoundId_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_startsWith?: InputMaybe<Scalars['String']['input']>;
  who?: InputMaybe<AccountWhereInput>;
  who_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VotingRoundsConnection = {
  __typename?: 'VotingRoundsConnection';
  edges: Array<VotingRoundEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Worker = {
  __typename?: 'Worker';
  /** Account */
  account: Account;
  /** Account address */
  id: Scalars['String']['output'];
  /** Worker nominations */
  nominations: Array<NominatedWorkerNode>;
  /** Submitted votes by account */
  votes: Array<Vote>;
};


export type WorkerNominationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NominatedWorkerNodeOrderByInput>>;
  where?: InputMaybe<NominatedWorkerNodeWhereInput>;
};


export type WorkerVotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoteOrderByInput>>;
  where?: InputMaybe<VoteWhereInput>;
};

export type WorkerEdge = {
  __typename?: 'WorkerEdge';
  cursor: Scalars['String']['output'];
  node: Worker;
};

export enum WorkerOrderByInput {
  AccountIdAsc = 'account_id_ASC',
  AccountIdAscNullsFirst = 'account_id_ASC_NULLS_FIRST',
  AccountIdAscNullsLast = 'account_id_ASC_NULLS_LAST',
  AccountIdDesc = 'account_id_DESC',
  AccountIdDescNullsFirst = 'account_id_DESC_NULLS_FIRST',
  AccountIdDescNullsLast = 'account_id_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST'
}

export type WorkerWhereInput = {
  AND?: InputMaybe<Array<WorkerWhereInput>>;
  OR?: InputMaybe<Array<WorkerWhereInput>>;
  account?: InputMaybe<AccountWhereInput>;
  account_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  nominations_every?: InputMaybe<NominatedWorkerNodeWhereInput>;
  nominations_none?: InputMaybe<NominatedWorkerNodeWhereInput>;
  nominations_some?: InputMaybe<NominatedWorkerNodeWhereInput>;
  votes_every?: InputMaybe<VoteWhereInput>;
  votes_none?: InputMaybe<VoteWhereInput>;
  votes_some?: InputMaybe<VoteWhereInput>;
};

export type WorkersConnection = {
  __typename?: 'WorkersConnection';
  edges: Array<WorkerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GetSolutionVotesPerRewardPeriodQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  solutionNamespace: Scalars['String']['input'];
  rewardPeriod: Scalars['Float']['input'];
}>;


export type GetSolutionVotesPerRewardPeriodQuery = { __typename?: 'Query', operatorNumberOfSubmissions: { __typename?: 'NumberOfSubmissions', numberOfSubmissions: number } };

export type GetTransactionsByPeriodQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  solutionId: Scalars['String']['input'];
  rewardPeriod: Scalars['Int']['input'];
}>;


export type GetTransactionsByPeriodQuery = { __typename?: 'Query', operatorById?: { __typename?: 'Operator', votes: Array<{ __typename?: 'Vote', blockHash?: string | null, extrinsicHash?: string | null, blockNumber: any, rewardPeriod?: { __typename?: 'RewardPeriod', index: number } | null, result?: { __typename?: 'VoteResult', result: string } | null, votingRound?: { __typename?: 'VotingRound', votingRoundId: string } | null }> } | null };

export type GetVotesByPeriodQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  rewardPeriod: Scalars['Int']['input'];
}>;


export type GetVotesByPeriodQuery = { __typename?: 'Query', operatorById?: { __typename?: 'Operator', votes: Array<{ __typename?: 'Vote', blockHash?: string | null, extrinsicHash?: string | null, blockNumber: any, rewardPeriod?: { __typename?: 'RewardPeriod', index: number } | null, solution: { __typename?: 'Solution', id: string }, result?: { __typename?: 'VoteResult', result: string } | null, votingRound?: { __typename?: 'VotingRound', votingRoundId: string } | null }> } | null };

export type GetVotingGraphDataQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  solutionNamespace: Scalars['String']['input'];
}>;


export type GetVotingGraphDataQuery = { __typename?: 'Query', operatorById?: { __typename?: 'Operator', votes: Array<{ __typename?: 'Vote', rewardPeriod?: { __typename?: 'RewardPeriod', index: number } | null, result?: { __typename?: 'VoteResult', result: string } | null }> } | null };


export const GetSolutionVotesPerRewardPeriodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSolutionVotesPerRewardPeriod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"solutionNamespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rewardPeriod"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorNumberOfSubmissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"operatorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rewardPeriodIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rewardPeriod"}}},{"kind":"Argument","name":{"kind":"Name","value":"solutionNamespace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"solutionNamespace"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfSubmissions"}}]}}]}}]} as unknown as DocumentNode<GetSolutionVotesPerRewardPeriodQuery, GetSolutionVotesPerRewardPeriodQueryVariables>;
export const GetTransactionsByPeriodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactionsByPeriod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"solutionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rewardPeriod"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"votes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rewardPeriod"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"index_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rewardPeriod"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"solution"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"solutionId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockHash"}},{"kind":"Field","name":{"kind":"Name","value":"extrinsicHash"}},{"kind":"Field","name":{"kind":"Name","value":"blockNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rewardPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"votingRound"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"votingRoundId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionsByPeriodQuery, GetTransactionsByPeriodQueryVariables>;
export const GetVotesByPeriodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVotesByPeriod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rewardPeriod"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"votes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rewardPeriod"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"index_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rewardPeriod"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockHash"}},{"kind":"Field","name":{"kind":"Name","value":"extrinsicHash"}},{"kind":"Field","name":{"kind":"Name","value":"blockNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rewardPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"votingRound"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"votingRoundId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVotesByPeriodQuery, GetVotesByPeriodQueryVariables>;
export const GetVotingGraphDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVotingGraphData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"solutionNamespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"votes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"solution"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"solutionNamespace"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVotingGraphDataQuery, GetVotingGraphDataQueryVariables>;